import styled from "styled-components";

export const Container = styled.div`
  & > div {
    display: flex;
    justify-content: flex-start;
  }
  & > div > span {
    margin-right: 10px;
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    color: #373737;
    cursor: pointer;
    transition: 0.7s !important;
    display: flex;
    align-items: center;
    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.main};
      color: white;
    }
  }
  & > div > span.selected {
  }
`;
